<template>
    <div tile class="my-4">
        <v-row>
            <v-col md="2" sm="3" cols="4">{{ $t("page.sectionEditor.class-name") }}</v-col>
            <v-col md="2" sm="3" cols="4">{{ $t("page.sectionEditor.excluded") }}</v-col>
            <v-col md="2" sm="3" cols="4" v-if="bModeSprint">{{ $t("page.sectionEditor.run-limit") }}</v-col>
        </v-row> 
        <v-row v-if="classes.length == 0">
            <v-col md="12" sm="12" cols="12" class="pt-0">
               <span class="warning--text"> <v-icon>mdi-alert</v-icon> {{ $t("page.sectionEditor.no-classes-found") }} </span>
            </v-col>
        </v-row>
        <v-form ref="formClasses">            
            <v-row v-for="rc in classes" :key="rc.id"  min-width="100%">
                <v-col md="2" sm="3" cols="4">{{ rc.name }}</v-col>
                <v-col md="2" sm="3" cols="4">
                    <v-switch
                        compact 
                        dense
                        v-model="rc.isExcluded"
                        color="red"
                        hide-details
                        @change="updateClass($event, rc, 'isExcluded');"
                        :label="rc.isExcluded ? $t('page.sectionEditor.excluded') : ''"
                    ></v-switch>
                </v-col>
                <v-col md="2" sm="3" cols="4" v-if="bModeSprint">
                    <v-select 
                        v-model="rc.runLimit"
                        :items="itemsRunLimit"
                        style="max-width: 160px"
                        outlined dense
                        @change="updateClass($event, rc, 'runLimit')"
                        :no-data-text="$t('common.no_data')"
                    ></v-select>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
    mixins: [apiCalls],
    props:["Section","RaceId","runLimit"],
    data () {
        return {
            classesThrownReference: [],
            labelIsExcludedClasses: [], 
            test: false,
            raceSectionClassReference: [],
            bStartClassThrown: false,
            bStartRaceSectionClass: false
        }
    },
    computed: {
        bModeSprint() {
            return this.Race && this.Race.mode == 10 && this.Race.subMode == 'sprint';
        },
        Race() {
            return this.$store.getters.getRaceSections;
        },
        RaceClasses() {
            return this.$store.getters.getClasses;
        },
        classesThrown() {
            let classesThrown = JSON.parse(this.Section.classesThrown);
            if(typeof classesThrown == 'object' && !Array.isArray(classesThrown) && classesThrown != null) {
                classesThrown = Object.values(classesThrown);
            } else if(!Array.isArray(classesThrown)) {
                classesThrown = [];
            }
            return classesThrown || [];
        },
        RaceSectionClass() {
            return this.Section.raceSectionClass;
        },
        classes() {

            const { classesThrownReference, RaceClasses, raceSectionClassReference, bModeSprint } = this;
            const classes = {};

            if(RaceClasses.length == 0) {
                return [];
            }

            RaceClasses.forEach((raceClass, index) => {
                const baseData = {
                    id: raceClass.id,
                    name: raceClass.name,
                    index
                };

                if (!bModeSprint) {
                    const isIncluded = classesThrownReference?.includes(raceClass.id) ?? false;
                    classes[raceClass.id] = {
                        ...baseData,
                        value: isIncluded ? 1 : 0,
                        isExcluded: isIncluded ? 1 : 0
                    };
                } else {
                    const ref = raceSectionClassReference.find(item => item.fkClassId === raceClass.id) || {};
                    classes[raceClass.id] = {
                        ...baseData,
                        raceClassId: ref.id,
                        value: ref.isExcluded ?? 0,
                        isExcluded: ref.isExcluded ?? 0,
                        runLimit: ref.runLimit ?? 1
                    };
                }
            });
            
            return classes;
        },
        raceSectionsClassUpdate() {
            let sectionsUpdate = this.$store.getters.getSectionsUpdate;
            let raceSectionClass = [];
            if(sectionsUpdate.length > 0) {
                sectionsUpdate.forEach((section) => {
                    if(section.sectionId == this.Section.id) {
                       raceSectionClass = section.raceSectionClass || [];
                    }
                });
            }
            return raceSectionClass;
        },
        SectionsUpdate() {
            return this.$store.getters.getSectionsUpdate;
        },
        itemsRunLimit() {
            let arrayInteger = [];
            for(let i = 1; i <= this.runLimit; i++) {
                arrayInteger.push(i);
            }
            return arrayInteger;
        }
    },
    methods:{
        filterThrownClasses(value, id) {
            if(value && !this.classesThrownReference.includes(id)) {
                this.classesThrownReference.push(id);
            } else if(!value) {
                this.classesThrownReference = this.classesThrownReference.filter(el => el != id);
            }
        },
        async updateClass(newValue, raceClass, field = false){
            if(!this.bModeSprint) {
                if(!Array.isArray(this.classesThrownReference)) {
                    this.classesThrownReference = [];
                }
                if(Array.isArray(this.classesThrownReference)) {
                    this.filterThrownClasses(newValue, raceClass.id);
                }
            } else {
                if(!Array.isArray(this.raceSectionClassReference)) {
                    this.raceSectionClassReference = [];
                }
                if(Array.isArray(this.raceSectionClassReference)) {
                    let findIndex = this.raceSectionClassReference.findIndex((el) => {
                        return el.fkClassId == raceClass.id;
                    });
                    
                    if(findIndex >= 0) {
                        this.raceSectionClassReference[findIndex][field] = newValue;
                    } else {
                        let item = {
                            fkClassId: raceClass.id, 
                            isExcluded: raceClass.isExcluded, 
                            runLimit: raceClass.runLimit,
                            id: raceClass.raceClassId
                        };
                        item[field] = newValue;
                        this.raceSectionClassReference.push(item);
                    }
                    this.$store.dispatch('addSectionCheckUpdateAction', { field: 'raceSectionClass', value: this.raceSectionClassReference, sectionId: this.Section.id });
                }
            }
        },
        updateRunLimit(applyAll) {
            //This is only available when in Enduro Sprint mode
            if(applyAll) {
                for (let key in this.classes) {
                    let el = this.classes[key];
                    let findIndex = this.raceSectionClassReference.findIndex((el1) => el1.fkClassId == el.id);
                    if(findIndex >= 0) {
                        this.raceSectionClassReference[findIndex].runLimit = parseInt(this.runLimit);
                    } else {
                        this.raceSectionClassReference.push({
                            fkClassId: el.id, 
                            isExcluded: el.isExcluded, 
                            runLimit: parseInt(this.runLimit),
                            id: el.raceClassId
                        });
                    }
                }
            } else {
                for (let key in this.classes) {
                    let el = this.classes[key];
                    let findIndex = this.raceSectionClassReference.findIndex((el1) => el1.fkClassId == el.id);
                    if(findIndex >= 0) {
                        if(this.raceSectionClassReference[findIndex].runLimit > this.runLimit) {
                            this.raceSectionClassReference[findIndex].runLimit = parseInt(this.runLimit);
                        }
                    } else if(el.runLimit > this.runLimit) {
                        this.raceSectionClassReference.push({
                            fkClassId: el.id, 
                            isExcluded: el.isExcluded, 
                            runLimit: parseInt(this.runLimit),
                            id: el.raceClassId
                        });
                    }
                }
            }
            this.$store.dispatch('addSectionCheckUpdateAction', { field: 'raceSectionClass', value: this.raceSectionClassReference, sectionId: this.Section.id });
        },
        loadRaceSectionClass() { 
            let raceSectionClassReference = this.RaceSectionClass.map((el) => {
                return {
                    fkClassId: el.fkClassId, 
                    isExcluded: el.isExcluded, 
                    runLimit: el.runLimit,
                    id: el.id
                };
            });
            this.raceSectionsClassUpdate.forEach((el) => {
                let findIndex = raceSectionClassReference.findIndex((el1) => el1.fkClassId == el.fkClassId);
                if(findIndex >= 0) {
                    raceSectionClassReference[findIndex].runLimit = el.runLimit;
                } else {
                    raceSectionClassReference.push(el);
                }
            });
            this.raceSectionClassReference = raceSectionClassReference;
        }
    }, 
    mounted() {
        this.classesThrownReference = this.classesThrown;
        this.loadRaceSectionClass();
    },
    watch: {
        /*classesThrown(val) {
            this.classesThrownReference = val;
        },*/
        RaceSectionClass() {
            this.loadRaceSectionClass();
        },
        classesThrownReference(val) {
            if(this.bStartClassThrown) {
                this.$store.dispatch('addSectionCheckUpdateAction', { field: 'classesThrown', value: val, sectionId: this.Section.id });
            } else {
                this.bStartClassThrown = true;
            }
        },
        raceSectionClassReference(val) {
            if(this.bStartRaceSectionClass) {
                this.$store.dispatch('addSectionCheckUpdateAction', { field: 'raceSectionClass', value: val, sectionId: this.Section.id });    
            } else {
                this.bStartRaceSectionClass = true;
            }
            
        },
        SectionsUpdate(val) {
            if((val || []).length == 0) {
                this.bStartClassThrown = false;
                this.bStartRaceSectionClass = false;
            }
        }
    }
}
</script>

<style scss>
.red--text label {
    color: #F44336 !important;
    caret-color: #F44336 !important;
}
</style>